var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 102,
    viewBox: "0 0 104 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.2549 0H42.3137L0 30V79.8462L28.0392 102L77.4902 62.3077V44.3077L27.0196 84L16.3137 75.2308V35.0769L65.2549 0Z",
    fill: "#28BDEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2157 66L49.451 56.3077L43.3333 51.2308V44.7692L75.9608 18.4615L87.6863 27.6923V66.9231L39.2549 102H61.6863L104 72.4615V23.5385L75.9608 0.461536L26 40.1538V57.2308L37.2157 66Z",
    fill: "#28BDEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDc);
export default __webpack_public_path__ + "static/media/logoDC.ff94d39e2b6dd15abb6053294fbcf4bd.svg";
export { ForwardRef as ReactComponent };